<script>
	import GameHistory from './GameHistory.svelte';
	
	let move = -1;
	$: board = move + 1;
	let gameHistory;
	
	const moves = [
		[1, 5], [2, 5], [1, 4], [2, 3], [2, 5], [2, 0], [1, 5], [1, 3], [1, 5], [1, 1], [2, 2], [2, 5], [2, 1], [2, 5], [2, 4], [1, 5], [1, 4], [2, 5], [2, 3], [2, 5], [2, 2], [1, 5], [1, 0], [2, 4], [1, 3], [2, 5]
	];
	
	let canvas;
	$: ctx = canvas && canvas.getContext('2d');
	function updateCanvas(board, ctx) {
		if (!ctx) return;
		ctx.clearRect(0, 0, 400, 200);
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.font = "20px sans-serif";
// 		ctx.strokeRect(2, 5, 398, 215);
		
		const { one, onePot, two, twoPot } = gameHistory[board];
		
		ctx.fillText(twoPot, 10+25, 10 + 66.66 * 1.5);
		
		ctx.beginPath();
		ctx.ellipse(10+25, 10+66.66*1.5, 20, 40, 0, Math.PI*2, false);
		ctx.stroke();
		
		ctx.beginPath();
		ctx.ellipse(400-25-10, 10+66.66*1.5, 20, 40, 0, Math.PI*2, false);
		ctx.stroke();
		
		ctx.fillText(onePot, 400-10-25, 10 + 66.66 * 1.5);
		
		for (let i=0; i<6; i++) {
			const leftOffset = 50 + i*50 + 25;
			ctx.fillText(two[i], leftOffset, 66.66-10);
			ctx.fillText(one[i], leftOffset, 200-66.66/2);
			ctx.beginPath();
			ctx.ellipse(leftOffset, 66.66-10, 20, 20, 0, Math.PI*2, false);
			ctx.stroke();
			ctx.beginPath();
			ctx.ellipse(leftOffset, 200-66.66/2, 20, 20, 0, Math.PI*2, false);
			ctx.stroke();
		}
		
		
	}
	
	$: updateCanvas(board, ctx);
</script>

<section>
	<canvas bind:this={canvas} width="400" height="220"></canvas>

	<input type="range" max={moves.length-1} min={-1} bind:value={move} />
	<ul>
		{#if moves[move]}
		<li>Player {moves[move][0]} moves {moves[move][1]}</li>
		{:else}
		<li>Start board</li>
		{/if}


		{#if moves[move-1]}
		<li style="opacity: 0.6">
			Player {moves[move-1][0]} moves {moves[move-1][1]}
		</li>
		{/if}

		{#if moves[move-2]}
		<li style="opacity: 0.25;">
			Player {moves[move-2][0]} moves {moves[move-2][1]}
		</li>
		{/if}
	</ul>

	<GameHistory bind:gameHistory={gameHistory} />
</section>

<style>
	input[type=range] {
		width: 80%;
		margin-top: 20px;
	}
	
	
	section {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	li:not(:nth-of-type(1)) {
		list-style: none;
	}
	
	canvas {
		margin-top: 20px;
		box-shadow: 0 0 10px;
	}
	
	ul {
		width: 400px;
		text-align: left;
	}
</style>